import React from 'react';

interface TableCellProps {
  className?: string;
  position: number;
  width: number;
  onClick?: () => void;
}

export const TableCell: React.FC<TableCellProps> = ({
  className = '',
  children,
  position,
  width,
  onClick = () => {},
}) => {
  const isFirstElement = position === 0;
  const isOneColumnView = width === 1;
  let classNames: string = '';

  isFirstElement && isOneColumnView && (classNames = 'w-40');
  isFirstElement && !isOneColumnView && (classNames = 'w-60');

  !isFirstElement && isOneColumnView && (classNames = 'w-30');
  !isFirstElement && !isOneColumnView && (classNames = 'w-36');

  return (
    <div
      className={`
            select-none
            flex
            flex-1
            items-center
            border-b
            border-grey-10
            h-10
            bg-white
            dark:bg-grey-90
            dark:border-grey-80
            truncate
            ${classNames}
            ${position === 1 && width !== 1 ? 'pl-5' : 'pl-0'}
            ${className}
          `}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
